import {gql} from "graphql-request";

export const CreateHikeWithPlannedTrails = gql`
  mutation CreateHikeWithPlannedTrails($input: CreateHikeInput!) {
    createHike(input: $input) {
      hike {
        id
        name
        description
        public
        createdAt
        updatedAt
        staticMapImageUrl
        ptv2PlannedTrails {
          id
          title
          distanceMeters
          elevationGainMeters
          thumbnailUrl
        }
        hikeHighlights {
          id
          type
          title
          description
          lonlat
          coordinates
          dayNumber
          clientId
          notificationDistance
          thumbnailUrl
          mediaAttachments {
            id
            clientId
            mediaType
            contentType
            title
            description
            url
            byteSize
          }
          createdAt
          updatedAt
        }
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const UpdateHikeWithPlannedTrails = gql`
  mutation UpdateHikeWithPlannedTrails($input: UpdateHikeInput!) {
    updateHike(input: $input) {
      hike {
        id
        name
        slug
        madeOfficialAt
        description
        public
        createdAt
        updatedAt
        staticMapImageUrl
        ptv2PlannedTrails {
          id
          title
          distanceMeters
          elevationGainMeters
          thumbnailUrl
        }
        hikeHighlights {
          id
          type
          title
          description
          lonlat
          coordinates
          dayNumber
          clientId
          notificationDistance
          thumbnailUrl
          mediaAttachments {
            id
            clientId
            mediaType
            contentType
            title
            description
            url
            byteSize
          }
          createdAt
          updatedAt
        }
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const GetHikeForTrailCard = gql`
  query GetHike($id: ID!) {
    hike(id: $id) {
      id
      name
      slug
      obfuscatedSlug
      description
      aiDescription
      aiDescriptionHighlight
      elevationGainMeters
      elevationLossMeters
      distanceMeters
      difficulty
      averageRating
      durationMinutes
      publiclyVisible
      createdAt
      updatedAt
      shareableUrl
      staticMapImageUrl
      geojsonRoutesOnlyString
      geojsonMultilinestringsWithStartEndPointsString
      startAddress {
        cityCountry
      }
      mainRegion {
        id
        name
        slug
      }
      mainCountry {
        id
        name
        slug
      }
      user {
        firebaseUserId
      }
      images {
        id
        file {
          url
        }
      }
    }
  }
`

export const GetHike = gql`
  query GetHike($id: ID!) {
    hike(id: $id) {
      id
      name
      slug
      description
      aiDescription
      aiDescriptionHighlight
      elevationGainMeters
      elevationLossMeters
      publiclyVisible
      createdAt
      updatedAt
      shareableUrl
      staticMapImageUrl
      trailType
      geojsonRoutesOnlyString
      geojsonMultilinestringsWithStartEndPointsString
      mainRegion {
        id
        name
        slug
      }
      mainCountry {
        id
        name
        slug
      }
      user {
        firebaseUserId
      }
      hikeDays {
        id
        dayNumber
        name
        description
      }
      hikeHighlights {
        id
        type
        title
        description
        lonlat
        coordinates
        dayNumber
        clientId
        notificationDistance
        images {
          file {
            mdUrl
            lgUrl
            smUrl
          }
        }
        mediaAttachments {
          id
          clientId
          mediaType
          contentType
          title
          description
          url
          byteSize
        }
        createdAt
        updatedAt
      }
      hikesPlannedTrails {
        id
        position
        day
        ptv2PlannedTrail {
          id
          title
          distanceMeters
          elevationGainMeters
          thumbnailUrl
          calculatedDurationMinutes
          createdAt
          routeStyle
          lineStrings {
            id
          }
          hikes {
            id
            name
            slug
          }
        }
      }
      images {
        id
        clientId
        isCover
        file {
          url
          smUrl
          mdUrl
          lgUrl
          signedId
        }
      }
    }
  }
`;

export const SearchHikes = gql`
  query SearchHikes(
    $query: String
    $publiclyVisible: Boolean
    $distanceMetersMin: Int
    $distanceMetersMax: Int
    $elevationGainMetersMin: Int
    $elevationGainMetersMax: Int
    $difficulties: [String!]
    $routeType: String
    $featureTags: [String!]
    $activityTags: [String!]
    $customTags: [String!]
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
    $sort: String
    $page: Int
    $perPage: Int
    $hideCompletedHikes: Boolean
  ) {
    searchUserHikes(
      query: $query
      publiclyVisible: $publiclyVisible
      distanceMetersMin: $distanceMetersMin
      distanceMetersMax: $distanceMetersMax
      elevationGainMetersMin: $elevationGainMetersMin
      elevationGainMetersMax: $elevationGainMetersMax
      difficulties: $difficulties
      routeType: $routeType
      featureTags: $featureTags
      activityTags: $activityTags
      customTags: $customTags
      startDate: $startDate
      endDate: $endDate
      sort: $sort
      page: $page
      perPage: $perPage
      hideCompletedHikes: $hideCompletedHikes
    ) {
      id
      name
      difficulty
      slug
      obfuscatedSlug
      description
      aiDescription
      aiDescriptionHighlight
      trailType
      elevationGainMeters
      elevationLossMeters
      distanceMeters
      publiclyVisible
      createdAt
      updatedAt
      durationMinutes
      durationDisplay
      staticMapImageUrl
      shareableUrl
      processingStatus
      madeOfficialAt
      officialHikeApprovalRequestedAt
      mainRegion {
        id
        name
        slug
      }
      mainCountry {
        id
        name
        slug
      }
      hikeDays {
        id
        dayNumber
        name
        description
      }
    }
  }
`;

export const SubmitHikeForOfficial = gql`
  mutation SubmitHikeForOfficial($input: SubmitHikeForOfficialInput!) {
    submitHikeForOfficial(input: $input) {
      hike {
        id
        madeOfficialAt
        officialHikeApprovalRequestedAt
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const DestroyHike = gql`
  mutation DestroyHike($input: DestroyHikeInput!) {
    destroyHike(input: $input) {
      id
    }
  }
`;

export const DestroyUserHikes = gql`
  mutation DestroyUserHikes($input: DestroyUserHikesInput!) {
    destroyUserHikes(input: $input) {
      destroyed
      destroyedCount
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const DuplicateHike = gql`
  mutation DuplicateHike($input: DuplicateHikeInput!) {
    duplicateHike(input: $input) {
      id
      name
      difficulty
      slug
      obfuscatedSlug
      description
      trailType
      elevationGainMeters
      elevationLossMeters
      distanceMeters
      publiclyVisible
      createdAt
      updatedAt
      durationMinutes
      durationDisplay
      staticMapImageUrl
      shareableUrl
      processingStatus
      mainRegion {
        id
        name
        slug
      }
      mainCountry {
        id
        name
        slug
      }
      hikeDays {
        id
        dayNumber
        name
        description
      }
    }
  }
`;

export const GetUserHikes = gql`
  query GetUserHikes($page: Int, $perPage: Int) {
    userHikes(page: $page, perPage: $perPage) {
      id
      name
      title
      slug
      description
      publiclyVisible
      createdAt
      updatedAt
      mainRegion {
        id
        name
        slug
      }
      mainCountry {
        id
        name
        slug
      }
      hikeDays {
        id
        dayNumber
        name
        description
      }
      hikesPlannedTrails {
        id
        position
        day
        ptv2PlannedTrail {
          id
          title
          distanceMeters
          elevationGainMeters
          elevationLossMeters
          thumbnailUrl
          calculatedDurationMinutes
          createdAt
          routeStyle
          lineStrings {
            id
          }
        }
      }
      ptv2PlannedTrails {
        id
        title
        distanceMeters
        elevationGainMeters
        elevationLossMeters
        thumbnailUrl
        calculatedDurationMinutes
        createdAt
        lineStrings {
          id
          routeStyle
        }
      }
    }
  }
`;

export const GetHikeWaypointsCount = gql`
  query GetHike($id: ID!) {
    hike(id: $id) {
      waypointsCount
      hikeHighlightsCount
    }
  }
`;

export const GetHikeExplore = gql`
  query GetHike($id: ID!) {
    hike(id: $id) {
      createdAt
      id
      name
      slug
      obfuscatedSlug
      elevationGainMeters
      elevationLossMeters
      distanceMeters
      difficulty
      averageRating
      durationMinutes
      shareableUrl
      geojsonRoutesOnlyString
      images {
        file {
          url
        }
      }
      staticMapImageUrl
      startAddress {
        cityCountry
      }
      mainCountry {
        slug
      }
      mainRegion {
        slug
      }
      user {
        firebaseUserId
      }
    }
  }
`;

export const GetHikeEncodedPolyline = gql`
  query GetHikeEncodedPolyline($id: ID!) {
    hikeOverviewPolyline(hikeId: $id)
  }
`;

export const SearchUserHikesSimple = gql`
  query SearchUserHikesSimple(
    $query: String
    $page: Int
    $perPage: Int
    $hideCompletedHikes: Boolean
  ) {
    searchUserHikes(
      query: $query
      page: $page
      perPage: $perPage
      hideCompletedHikes: $hideCompletedHikes
    ) {
      id
      name
      slug
      obfuscatedSlug
      distanceMeters
      elevationGainMeters
      difficulty
      averageRating
      commentsCount
      ratingsCount
      staticMapImageUrl
      shareableUrl
      mainRegion {
        name
      }
      mainCountry {
        name
      }
    }
  }
`;

export const SearchUserHikesCount = gql`
  query SearchUserHikesCount($query: String) {
    searchUserHikesCount(query: $query)
  }
`;

export const UpdateHikeDetails = gql`
  mutation UpdateHikeDetails($input: UpdateHikeDetailsInput!) {
    updateHikeDetails(input: $input) {
      hike {
        id
        name
        description
        difficulty
        publiclyVisible
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const GetHikeByLegacy = gql`
  query GetHikeByLegacy($legacyId: ID!, $legacyType: String!) {
    hikeByLegacy(legacyId: $legacyId, legacyType: $legacyType) {
      id
      name
      slug
      obfuscatedSlug
      description
      aiDescription
      aiDescriptionHighlight
      elevationGainMeters
      elevationLossMeters
      distanceMeters
      difficulty
      averageRating
      durationMinutes
      publiclyVisible
      createdAt
      updatedAt
      shareableUrl
      staticMapImageUrl
      geojsonRoutesOnlyString
      geojsonMultilinestringsWithStartEndPointsString
      startAddress {
        cityCountry
      }
      mainRegion {
        id
        name
        slug
      }
      mainCountry {
        id
        name
        slug
      }
      user {
        firebaseUserId
      }
      images {
        id
        file {
          url
        }
      }
    }
  }
`;
